// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rows-explain-wrapper{display:flex;align-items:center;background:#fff}.rows-explain-wrapper .rows-explain-block{margin-right:8px;width:6px;height:20px;background:#45a321}.rows-explain-wrapper .rows-explain-title{height:24px;font-size:18px;font-weight:500;color:#495973;line-height:24px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
